import type { QueryFunctionContext } from '@tanstack/react-query'
import type { AxiosRequestHeaders } from 'axios'
import type { RaRecord } from './types'
import { parsePaginatedApiParams } from '@repo/shared-core-utilities-http-clients/pagination/parsePaginatedApiParams'
import { axios } from '@repo/shared-core-utilities-http-clients/axios/axios'

type Dictionary<T> = Record<string, T>

// -----------------------------------------  GET ONE DEFAULT QUERY  ----------------------------------------- //

export interface GetOneParams<RecordType extends RaRecord = any> {
  id: RecordType['id']
}

type GetOneQueryKey = readonly [resource: string, params: GetOneParams]

export async function getOneBaseReactQuery(variables: any, context: QueryFunctionContext<GetOneQueryKey> | any) {
  // console.log('variables: ', variables, ' | context: ', context)

  const {
    queryKey: [resource, params],
    signal,
    meta
  } = context

  const queryString = `/api/${resource}/${params?.id}`

  // Headers - required for NextAuth Authorization
  const headers: AxiosRequestHeaders = meta?.cookie ? { cookie: meta?.cookie } : (undefined as any)

  const results = await axios.get(queryString, { signal, headers })

  return results.data
}

// -----------------------------------------  GET MANY DEFAULT QUERY  ----------------------------------------- //

interface GetManyVariables {
  where?: Dictionary<any>
  orderBy?: Dictionary<any>
  page?: number
  pageSize?: number
}

const defaultParams = { where: undefined, orderBy: undefined, page: 0, pageSize: 10 }

type GetManyQueryKey = [resource: string, params?: GetManyVariables]

// export async function getManyBaseReactQuery({ queryKey: [resource, params = defaultParams], signal, meta }: QueryFunctionContext<GetManyQueryKey>) {
export async function getManyBaseReactQuery(variables: any, context: QueryFunctionContext<GetManyQueryKey> | any) {
  // console.log('baseReactQuery | queryKey: ', resource, ' | params: ', params, ' | signal: ', signal, ' | meta: ', meta)
  // console.log('variables: ', variables, ' | context: ', context)

  const {
    queryKey: [resource, params = defaultParams],
    signal,
    meta
  } = context

  const BASE = `api/${resource}`

  const queryString = parsePaginatedApiParams(BASE, params)

  // console.log('queryString: ', queryString)

  // Headers - required for NextAuth Authorization
  const headers: AxiosRequestHeaders = meta?.cookie ? { cookie: meta?.cookie } : (undefined as any)

  const results = await axios.get(queryString, { signal, headers })

  return results.data
}

// -----------------------------------------  UPDATE DEFAULT QUERY  ----------------------------------------- //

interface UpdateVariables {
  id: number
  data: any
}

type UpdateQueryKey = [resource: string, variables: UpdateVariables]

export async function updateBaseReactQuery({ queryKey: [resource, variables] }) {
  const url = `api/${resource}/${variables?.id}`

  const results = await axios.put(url, { ...variables.data })

  return results.data
}

// -----------------------------------------  CREATE DEFAULT QUERY  ----------------------------------------- //

interface CreateVariables {
  data: any
}

type CreateQueryKey = [resource: string, variables: CreateVariables]

export async function createBaseReactQuery({ queryKey: [resource, variables] }) {
  const url = `api/${resource}`

  const results = await axios.post(url, { ...variables.data })

  return results.data
}

export const defaultMutationFn = async ({ queryKey }) => {
  const { data } = await axios.post(`api/${queryKey[0]}`)
  return data
}
